import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

const NotFoundPage = () => {
    return (
        <Container maxWidth="md">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '70vh',
                    textAlign: 'center',
                    py: 8,
                }}
            >
                <Typography
                    variant="h1"
                    color="text.secondary"
                    sx={{
                        fontSize: { xs: '6rem', md: '10rem' },
                        fontWeight: 700,
                        mb: 2,
                    }}
                >
                    404
                </Typography>
                <Typography variant="h4" gutterBottom>
                    Page Not Found
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    paragraph
                    sx={{ maxWidth: '600px', mb: 4 }}
                >
                    The page you are looking for might have been removed, had
                    its name changed, or is temporarily unavailable.
                </Typography>
                <Button
                    component={RouterLink}
                    to="/"
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<HomeIcon />}
                >
                    Back to Home
                </Button>
            </Box>
        </Container>
    );
};

export default NotFoundPage;
